import supabase from "@/services/supabaseClient";

export async function sendAppointmentEventEmail({ appointmentId, eventType } = {}) {
  const cleanAppointmentId = String(appointmentId || "").trim();
  const cleanEventType = String(eventType || "").trim();

  if (!cleanAppointmentId || !cleanEventType) {
    return { ok: false, skipped: true, reason: "missing_required_fields" };
  }

  const { data, error } = await supabase.functions.invoke("send-appointment-event-email", {
    body: {
      appointment_id: cleanAppointmentId,
      event_type: cleanEventType,
    },
  });

  if (error) throw error;
  return data;
}
